import React from 'react';
import './ColorChip.css';

const ColorChip = ({ color, isActive, onClick }) => {
  const handleClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    onClick && onClick(e);
  };

  return (
    <button
      type="button"
      className={`color-chip ${isActive ? 'active' : ''}`}
      onClick={handleClick}
    >
      <span 
        className="color-chip-swatch"
        style={{ backgroundColor: color.hex_code }}
      ></span>
      <span className="color-chip-name">{color.name}</span>
    </button>
  );
};

export default ColorChip;



